import { useLocation } from '@reach/router';
import { ThemeInterface, User } from '@redux/prop-types';
import { themeSelector, userSelector } from '@redux/selectors';
import { useUserAccess } from '@utils/hooks/use-user-access';
import { isDarkMode } from '@utils/theme';
import React, { FC } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import darkLogo from '../../../assets/images/logo-devstart-dark.svg';
import lightLogo from '../../../assets/images/logo-devstart-light.svg';
import sctecDarkLogo from '../../../assets/images/logo-sctec-dark.png';
import sctecLightLogo from '../../../assets/images/logo-sctec-light.png';
import { Link } from '../../helpers';

import './nav-logo.css';

export interface NavLogoProps {
  theme: ThemeInterface;
  user: User;
}

const NavLogo: FC<NavLogoProps> = ({ theme, user }): JSX.Element => {
  const location = useLocation();
  const { isSCTEC } = useUserAccess(user);

  const quizPaths = ['/quiz', '/register/national-form'];
  const isQuizPath = quizPaths.some(path => location.pathname.includes(path));
  const to = isQuizPath ? '/quiz' : '/learn';

  const isDark = isDarkMode(theme?.currentTheme);

  const devstartLogo = isDark ? darkLogo : lightLogo;
  const sctecLogo = isDark ? sctecDarkLogo : sctecLightLogo;

  return (
    <Link id='link-nav-logo' to={to}>
      {isSCTEC ? (
        <span className='nav-logo-sctec'>
          <img src={sctecLogo} alt='logo SCTEC' height={24} />
          <span className={`nav-logo-divider ${isDark ? 'dark' : 'light'}`} />
          <img src={devstartLogo} alt='logo DEVstart' height={20} />
        </span>
      ) : (
        <img src={devstartLogo} alt='logo DEVstart' width={140} />
      )}
    </Link>
  );
};

NavLogo.displayName = 'NavLogo';

const mapStateToProps = createSelector(
  themeSelector,
  userSelector,
  (theme: ThemeInterface, user: User) => ({
    theme,
    user
  })
);
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NavLogo);
